import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';
import {changeContextMode, hideMenus} from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import { addStorySound } from '../../actions/ProductionActions';
import audioUtils from '../utils/AudioUtils';
import locales from '../../locales/LocalesManager';
import { VolumeSlider } from '../menus/VolumeSlider';
import saveManager from '../utils/SaveManager';
import mouseUtils from '../../components/utils/MouseUtils';
import zoomUtils from '../../components/utils/ZoomUtils';
import animator from '../../components/utils/Animator';
import platformDetection from '../../components/utils/PlatformDetection';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import { deleteItem } from '../../actions/AudioEditorActions';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import appParameters from '../utils/AppParameters';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import audioVolumeUtils from '../utils/AudioVolumeUtils';
import textSizeUtils from '../utils/TextSizeUtils';

export const MusicMenuContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            isCloseOver: false,
            isPlayOver: false,
            isVolumeOver: false,
            isSoundTitleOver: false,
            openVolumeSlider: false,
            isPlaying: false,
            isDeleteOver: false
        };
    },
    componentDidMount() {
        document.addEventListener('click', this.onCloseVolumeSlider);
        document.addEventListener('touchend', this.onCloseVolumeSlider);

        if (!audioVolumeUtils.useVolumeFunctionality())
            audioUtils.initMusicSound(this.updatePlayingStatus);
    },
    componentWillUnmount() {
        document.removeEventListener('click', this.onCloseVolumeSlider);
        document.removeEventListener('touchend', this.onCloseVolumeSlider);

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.executeMediaAction('storySoundItem', 0, false);
        else
            audioUtils.cleanMusicSound();
    },
    componentWillReceiveProps(nextProps) {
        if (this.props.currentSlideIndex != nextProps.currentSlideIndex) {
            this.stopSound();
        }
    },
    onDeleteMouseIn () {
        hoverManager.show(this.refs.delete, 'deleteAudioItem');

        this.setState({
            isDeleteOver: true
        });
    },
    onDeleteMouseOut () {
        hoverManager.hide();

        this.setState({
            isDeleteOver: false
        });
    },
    onDelete(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(deleteItem());
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();
        audioEditorUtils.checkTimelineWidth();
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onSoundTitleMouseIn () {
        this.setState({
            isSoundTitleOver: true
        });
    },
    onSoundTitleMouseOut () {
        this.setState({
            isSoundTitleOver: false
        });
    },
    onCloseMouseIn () {
        hoverManager.show(this.refs.deleteSound, 'deleteSound', 'right');

        this.setState({
            isCloseOver: true
        });
    },
    onCloseMouseOut () {
        hoverManager.hide();

        this.setState({
            isCloseOver: false
        });
    },
    onPlayMouseIn () {
        hoverManager.show(this.refs.playSound, 'playSound');

        this.setState({
            isPlayOver: true
        });
    },
    onPlayMouseOut () {
        hoverManager.hide();

        this.setState({
            isPlayOver: false
        });
    },
    onVolumeMouseIn () {
        hoverManager.show(this.refs.volumeSound, 'volumeSound');

        this.setState({
            isVolumeOver: true
        });
    },
    onVolumeMouseOut () {
        hoverManager.hide();

        this.setState({
            isVolumeOver: false
        });
    },
    onCloseVolumeSlider (e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!platformDetection.isIOS()) {
            if (!document.getElementById('htmlColorPicker'))
                e.preventDefault();
        }

        const target = e.target;

        if (target.id == 'volume')
            return;

        if (target.id && target.id.indexOf('volumeIcon') != -1) {
            this.setState({
                openVolumeSlider: false
            });

            return;
        }

        if (target.id.indexOf('volumeSlider') != -1 || (target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1) || (target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1))
            return;

        this.setState({
            openVolumeSlider: false
        });
    },
    onOpenVolumeSlider (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            openVolumeSlider: true
        });
    },
    onOpenAudioBrowser (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        zoomUtils.closeZoom();

        this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));

        if (!playController.isAudioEditorMode())
            playController.checkAudioEditorModeWhenOpenAudioMenus(0);
        else
            playController.toggleAudioEditorMode();
    },
    onClose(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(addStorySound(undefined));
        saveManager.isContentChanged(true);
    },
    stopSound() {
        if (this.state.isPlaying) {
            if (audioVolumeUtils.useVolumeFunctionality())
                audioVolumeUtils.executeMediaAction('storySoundItem', 0, false);
            else
                audioUtils.pauseSound('musicSoundId');
        }
    },
    onPlay(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var volume = storeManager.getState().production.storySoundVolume;

        if (volume == undefined)
            volume = 0.5;

        if (audioVolumeUtils.useVolumeFunctionality()) {
            audioVolumeUtils.executeMediaAction('storySoundItem', volume, !this.state.isPlaying, this.onEndSound);
            this.updatePlayingStatus(!this.state.isPlaying);
        } else {
            var audio = this.refs.audio;

            if (audio)
                audio.volume = volume;

            if (!this.state.isPlaying)
                audioUtils.playSound('musicSoundId');
            else
                audioUtils.pauseSound('musicSoundId');
        }
    },
    onEndSound() {
        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.executeMediaAction('audioStory', 0, false);

        this.updatePlayingStatus(false);
    },
    updatePlayingStatus(value) {
        this.setState({
            isPlaying: value
        });

        this.forceUpdate();
    },
    showStorySound() {
        if (this.props.storySound != undefined)
            return true;
        else
            return false;
    },
    getTitle() {
        if (this.props.storySound)
            return this.props.storySound.title;
        else
            return '';
    },
    getSoundSource() {
        var value;

        if (this.props.storySound)
            value = this.props.storySound.href;

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.checkSound(value, 'storySoundItem');
        else
            audioUtils.updateHrefForMusicSound(value);

        return value;
    },
    getSoundIcon() {
        var soundVolume = this.props.storySoundVolume;

        if (!soundVolume)
            soundVolume = 0.5;
        else
            soundVolume = parseFloat(soundVolume);

        var volumeIcon = 'fa fa-volume-down';

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up';

        return volumeIcon;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.storySound != newProps.storySound && newProps.storySound != undefined)
            animator.startAnimation('storySoundItem');

        if (newProps.isPlaying != this.state.isPlaying || this.state.isOver != nextState.isOver || this.state.isCloseOver != nextState.isCloseOver || this.state.isPlayOver != nextState.isPlayOver || this.state.isVolumeOver != nextState.isVolumeOver || this.state.isSoundTitleOver != nextState.isSoundTitleOver || this.state.openVolumeSlider != nextState.openVolumeSlider || this.props.storySound != newProps.storySound || this.props.currentSlideIndex != newProps.currentSlideIndex  || this.props.timelines != newProps.timelines)
            return true;
        else
            return false;
    },
    render() {
        var menuWidth = audioToolUtils.buttonsHolderWidth() - 2 * properties.BUTTONS_HOLDER_LEFT_GAP;
        const slideViewerHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP + properties.SLIDE_VIEWER_BOTTOM_GAP + properties.SLIDE_VIEWER_LIST_HEIGHT;
        const originalHolderWidh = menuWidth;

        const menuStyle = {
            position: 'absolute',
            width: menuWidth,
            height: properties.ADD_MUSIC_BUTTON_HEIGHT,
            left: properties.BUTTONS_HOLDER_LEFT_GAP,
            top: slideViewerHeight - properties.SLIDE_VIEWER_BOTTOM_GAP - properties.ADD_MUSIC_BUTTON_HEIGHT,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none'
        };

        var borderColor;
        var iconColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }
        else {
            borderColor = properties.ADD_MUSIC_BUTTON_BACKGROUND;
            iconColor = 'black';
        }

        const addMusicTitleLeftPosition = 33;
        var musicButtonCaption = locales.getCaption('AddMusic', 'music');

        if (playController.isAudioEditorAvailable()) {
            if (!playController.isAudioEditorMode())
                musicButtonCaption = locales.getCaption('OpenAudioMode', 'music');
            else
                musicButtonCaption = locales.getCaption('CloseAudioMode', 'music');
        }

        var addMusicButtonStyle = {
            width: menuWidth,
            height: properties.ADD_MUSIC_BUTTON_HEIGHT,
            background: properties.ADD_MUSIC_BUTTON_BACKGROUND,
            position: 'absolute',
            left: 0,
            top: 0,
            borderRadius: 20,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        var offset = 0;

        if (platformDetection.isChromeBook() == true)
            offset = 2;

        var musicIconStyle = {
            position: 'absolute',
            top: 5 + offset,
            left: 13,
            color: iconColor
        };

        var spanStyle = {
            fontSize: 12,
            height: 20,
            width: menuWidth - addMusicTitleLeftPosition - 5,
            position: 'absolute',
            top: 7,
            left: addMusicTitleLeftPosition,
            color: iconColor,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        if (playController.isAudioEditorAvailable()) {
            if (playController.isAudioEditorMode()) {
                menuWidth = menuWidth - properties.SLIDE_VIEWER_BUTTON_WIDTH - properties.BUTTONS_HOLDER_LEFT_GAP;
                addMusicButtonStyle.width = menuWidth;
            }

            musicIconStyle.display = 'none';
            spanStyle.width = menuWidth - 10;
            spanStyle.left = 5;
            spanStyle.textAlign = 'center';
        }

        // story sound
        var storySoundDisplayState = 'none';

        if (this.showStorySound() == true)
            storySoundDisplayState = 'block';

        const title = this.getTitle();
        const titleLeftPosition = 64;

        const storySoundButtonStyle = {
            width: menuWidth,
            height: properties.ADD_MUSIC_BUTTON_HEIGHT,
            background: properties.ADD_MUSIC_BUTTON_BACKGROUND,
            position: 'absolute',
            left: 0,
            top: 0,
            borderRadius: 20,
            display: storySoundDisplayState
        };

        if (this.state.isPlayOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        var playIconStyle = {
            position: 'absolute',
            top: 5,
            left: 12,
            color: iconColor
        };

        if (this.state.isVolumeOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        var volumeIconStyle = {
            position: 'absolute',
            top: 5,
            left: 39,
            color: iconColor
        };

        if (this.state.isSoundTitleOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        const soundTitleStyle = {
            fontSize: 12,
            height: 20,
            width: menuWidth - 95,
            position: 'absolute',
            top: 7,
            left: titleLeftPosition,
            cursor: 'default',
            color: iconColor,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        };

        var playIconSrc = 'fa fa-play';

        if (this.state.isPlaying)
            playIconSrc = 'fa fa-pause';

        var playAreaStyle = {
            position: 'absolute',
            width: 28,
            height: 30,
            left: 0,
            top: 0,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        var volumeAreaStyle = {
            position: 'absolute',
            width: 28,
            height: 30,
            left: 30,
            top: 0,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        if (this.state.isCloseOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        var closeIconStyle = {
            position: 'absolute',
            top: 5,
            left: 183,
            color: iconColor
        };

        var closeAreaStyle = {
            position: 'absolute',
            width: 30,
            height: 30,
            left: 176,
            top: 0,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        var iconType = this.getSoundIcon();

        var storySoundElement;
        var deleteSoundButton;

        if (!playController.isAudioEditorAvailable()) {
            storySoundElement = <div ref="storySound" id="storySoundItem" style={storySoundButtonStyle}>
                <i style={playIconStyle} className={playIconSrc + ' colorAnimation'}></i>
                <button aria-label={locales.getCaption('playSound', 'hover')} ref='playSound' style={playAreaStyle} onClick={this.onPlay} onTouchEnd={this.onPlay} onMouseOver={this.onPlayMouseIn} onMouseOut={this.onPlayMouseOut}/>
                <i style={volumeIconStyle} className={iconType + ' colorAnimation'}></i>
                <button aria-label={locales.getCaption('volumeSound', 'hover')} ref='volumeSound' id='volume' style={volumeAreaStyle} onMouseOver={this.onVolumeMouseIn} onMouseOut={this.onVolumeMouseOut} onClick={this.onOpenVolumeSlider} onTouchEnd={this.onOpenVolumeSlider}/>
                <div className='colorAnimation' style={soundTitleStyle} onClick={this.onOpenAudioBrowser} onTouchEnd={this.onOpenAudioBrowser} onMouseOver={this.onSoundTitleMouseIn} onMouseOut={this.onSoundTitleMouseOut}>{title}</div>
                <i style={closeIconStyle} className="fa fa-close colorAnimation"></i>
                <button aria-label={locales.getCaption('deleteSound', 'hover')} ref='deleteSound' style={closeAreaStyle} onClick={this.onClose} onTouchEnd={this.onClose} onMouseOver={this.onCloseMouseIn} onMouseOut={this.onCloseMouseOut}/>
                <VolumeSlider dispatch={this.props.dispatch} visible={this.state.openVolumeSlider}/>
            </div>;
        } else {
            if (playController.isAudioEditorMode()) {
                var isAudioSelected = audioEditorUtils.isAudioSelected();
                var opacity = 1.0;
                var deleteSrc = appParameters.RESOURCES_LOCATION() + 'assets/trash.svg';
                var tabIndexDelete;

                if (!isAudioSelected) {
                    opacity = 0.6;
                    tabIndexDelete = '-1';
                } else {
                    if (this.state.isDeleteOver == true)
                        deleteSrc = appParameters.RESOURCES_LOCATION() + 'assets/trash_hover.svg';
                }

                const deleteSoundButtonStyle = {
                    width: properties.ADD_MUSIC_BUTTON_HEIGHT,
                    height: properties.ADD_MUSIC_BUTTON_HEIGHT,
                    background: properties.ADD_MUSIC_BUTTON_BACKGROUND,
                    position: 'absolute',
                    left: originalHolderWidh - properties.ADD_MUSIC_BUTTON_HEIGHT - (properties.SLIDE_VIEWER_BUTTON_WIDTH - properties.ADD_MUSIC_BUTTON_HEIGHT) / 2,
                    top: 0,
                    borderRadius: 50,
                    opacity,
                    margin: 0,
                    padding: 0,
                    boxSizing: 'initial',
                    fontSize: 'initial',
                    borderStyle: 'none'
                };

                var deleteIconStyle = {
                    position: 'absolute',
                    top: 0,
                    left: 0
                };

                deleteSoundButton =
                <button tabIndex={tabIndexDelete} aria-disabled={tabIndexDelete == '-1' ? true : false} aria-label={locales.getCaption('deleteAudioItem', 'hover')} ref='delete' style={deleteSoundButtonStyle} onMouseOver={this.onDeleteMouseIn} onMouseOut={this.onDeleteMouseOut} onTouchStart={this.onDelete} onClick={this.onDelete}>
                    <img alt='' aria-hidden='true' style={deleteIconStyle} src={deleteSrc}/>
                </button>;
            }
        }

        var tabIndexValue;

        if (storySoundElement && storySoundDisplayState == 'block')
            tabIndexValue = '-1';

        return (
            <div id='storySoundHolder' style={menuStyle}>
                <audio src={this.getSoundSource()} ref='audio' id='musicSoundId' className='audioItem' preload='auto' playsInline/>
                <button tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} aria-label={musicButtonCaption} ref="addMusic" style={addMusicButtonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onOpenAudioBrowser} onTouchEnd={this.onOpenAudioBrowser}>
                    <i style={musicIconStyle} className="fa fa-music"></i>
                    <span style={spanStyle}>{musicButtonCaption}</span>
                </button>
                {storySoundElement}
                {deleteSoundButton}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const storySound = state.production.storySound;
    const storySoundVolume = state.production.storySoundVolume;
    const currentSlideIndex = state.currentSlide.currentSlideIndex;
    const showAudioEditor = state.menu.showAudioEditor;
    const timelines = state.audioEditor.timelines;

    return {
        storySound,
        currentSlideIndex,
        storySoundVolume,
        showAudioEditor,
        timelines
    };
}

export const MusicMenu = connect(mapStateToProps)(MusicMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/slideViewer/MusicMenu.js
 **/